<template>
  <div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"></Loading>
    </div>
    <div v-if="isLoaded">
      <b-row>
        <b-col md="12">
          <label>{{label ? label : "Receptura oblewanych produktów:"}}</label>
        </b-col>

        <b-col md="12" class="d-flex" style="gap:10px">
          <div>
            <EcoConventionIcon :productType="selectedRecipe.recipeType" />
          </div>
          <div style="width:100%">
            <v-select label="name" :options="recepies" v-model="selectedRecipe" @input="changeItemOnList" />
          </div>
        </b-col>
      </b-row>

      <div class="container" v-if="selectedRecipe && selectedRecipe.ingredients">
        <table class="table mt-2">
          <thead>
            <tr>
              <th>Nazwa</th>
              <th>Ilość</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ingredient in selectedRecipe.ingredients" :key="ingredient.id">
              <td>
                <EcoConventionIcon :productType="ingredient.productType" />
                {{ ingredient.name }}
              </td>
              <td>{{ ingredient.weight }} kg</td>
            </tr>
            <tr class="table-secondary">
              <td>Łączna suma</td>
              <td>{{ totalSum }} kg</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import EcoConventionIcon from "../../../common/ecoConventionIcon.vue";
import Loading from "../../Common/Loading";
import FloatHelperMixins from "../../../mixins/floatHelper";
import RecipesMixin from "../../../mixins/recipes";


export default {
  name: "DisplayRecipeCoating",
  components: { Loading, EcoConventionIcon },
  mixins: [FloatHelperMixins,RecipesMixin],
  props: [
      "recipeId",
    "allowedRecipeTypes",
    "label",
    "couvertureRecipeId", //To property jest po to aby w tworzeniu np. czekolady z produktem nie pokazywać wszystkich receptur. Mamy pokazać tylko te które mają konkretną kuwerturę.
  ],
  computed: {
    recepies() {
      var results = [];
      if (this.allowedRecipeTypes) {
        var recipeTypeIds = this.allowedRecipeTypes;
        results= this.$store.state.productionHall.recipeCoating.filter(x => recipeTypeIds.includes(x.type))
      }else{
        results = this.$store.state.productionHall.recipeCoating;
      }

      const couvertureRecipeId = this.couvertureRecipeId;
      const materialTypeCouverture = this.materialTypes.couverture
      if(couvertureRecipeId){
        results= results.filter(function(recipe) {
          return recipe.ingredients.some(function(ingredient) {
            return ingredient.ingredientId === couvertureRecipeId && ingredient.materialType === materialTypeCouverture;
          });
        });
      }

      return results;
    },
    totalSum() {
      if (this.selectedRecipe.ingredients) {
        return this.selectedRecipe.ingredients
          .map((x) => x.weight)
          .reduce(function (a, b) {
            return a + b;
          }, 0)
          .toFixed(3);
      } else {
        return 0;
      }
    },
  },
  mounted() {
    var that = this;
    this.$store.dispatch("getCuvertureFormData").then(function () {
      that.isLoaded = true;
    });
    if (this.recipeId) {
      this.selectedRecipe = this.recepies.filter(
        (x) => x.id == this.recipeId
      )[0];
    }
  },
  data() {
    return {
      isLoaded: false,
      selectedRecipe: {},
    };
  },
  methods: {
    changeItemOnList(item) {
      this.$emit("selectedRecepie", item);
    },
  },
};
</script>